'use client'

import { motion, MotionValue, useTransform } from 'framer-motion'
import cx from 'classnames'
import { ImgBg } from './imgBg'
import style from './circle-bg.module.scss'

export const CircleBg = ({
  scrollYProgress,
  className,
}: {
  scrollYProgress: MotionValue<number>
  className?: string
}) => {
  const bgImgY = useTransform(scrollYProgress, [0, 1], ['0%', '20%'])

  return (
    <motion.div className={style.paralaxImg} style={{ y: bgImgY }}>
      <ImgBg className={cx(style.imgBg, className)} />
    </motion.div>
  )
}
